import * as React from "react";
import "./sentence.scss";
import { Sentence } from "../../api/TypedReportApi";

const Sentence = (props: { value: Sentence; displayTkType?: boolean }) => (
  <div className="sentence">
    {props.value.tokens.map((token, ti) => (
      <div key={ti} className="token">
        {props.displayTkType && <div className="token-type">{token.type.toLowerCase()}</div>}
        <span className={"token-text " + token.type.toLowerCase()}>{token.text}</span>
      </div>
    ))}
  </div>
);
export default Sentence;
